import * as Sentry from "@sentry/browser";

/**
 * @typedef SentryConfig
 * @property {'development' | 'staging' | 'production'} environment What Sentry Env to send the events to
 */

export function initalizeSentry() {
  /** @type {SentryConfig} */
  const sentryConfig = CONFIG.SENTRY;
  const { environment } = sentryConfig;
  
  // Only send errors to Sentry if app is running in staging or production
  if (!['staging', 'production'].includes(environment)) {
    console.info(`Not initializing sentry because sentry env is ${environment}`);
    return;
  }
  
  Sentry.init({
    // DSN doesn't change between Sentry ENVs, so it can be hard coded here
    dsn: "https://d97d57ac76d84fd8a4abd5a7f08c45c2@o1235227.ingest.sentry.io/4505053029203968",
    environment: environment,

    // Alternatively, use `process.env.npm_package_version` for a dynamic release version
    // if your build tool supports it.
    release: "my-project-name@2.3.12", // TODO: Update this release name?
    integrations: [
      // Sentry.browserTracingIntegration(), // Un-comment to enable performance monitoring
      Sentry.replayIntegration(),
    ],
  
    // Set tracesSampleRate to 0.0 to capture 0%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    // tracesSampleRate: 1.0, // Used with broswerTracingIntegration
  
    // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
    // tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/], // Used with broswerTracingIntegration
  
    // A global sample rate to apply to all events.
    // 0.0 = 0% chance of a given event being sent (send no events) 1.0 = 100% chance of a given event being sent (send all events)
    // sampleRate: 1.0,

    // Capture Replay for 0% of all sessions,
    replaysSessionSampleRate: 0.0,

    // Capture 100% of sessions with an error
    replaysOnErrorSampleRate: 1.0,
  });
}